<template>
  <div class="header-midd">
    <div style="width:calc(100% - 125px)">
      <el-form ref="form" size="small" inline :model="form">
        <el-form-item v-if="showPrjSelect" label="所属项目">
          <el-select v-model="form.prjId" size="small" clearable filterable>
            <el-option v-for="item in approvalProjectList" :key="item.prjId" :label="item.prjCode+'-'+item.prjName"
              :value="item.prjId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showflowTypeSelect" label="流程类型">
          <el-select v-model="form.flowType" size="small" clearable>
            <el-option v-for="item in definitionList" :key="item.flowDefinitionId" :label="item.flowName"
              :value="item.flowDefinitionId" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="showPrjKeywords" label="关键字查询">
          <el-input v-model="form.keywords" size="small" :placeholder="keywordsPlaceholder" clearable>
          </el-input>
        </el-form-item>
        <el-form-item v-if="showApplicantSelect" label="申请人">
          <el-select v-model="form.flowInstanceOwnerId" size="small" clearable>
            <el-option v-for="item in userList" :key="item.flowInstanceOwnerID" :value="item.flowInstanceOwnerID"
              :label="item.flowInstanceOwnerName+'('+item.flowInstanceOwnerUserName+')'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showStatusSelect" label="审批状态">
          <el-select v-model="form.status" size="small" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker v-model="form.approveTime" type="daterange" value-format="yyyy-MM-dd"
            range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" size="small">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="showSpecIdSelect" label="专业" label-width="68px">
          <el-select v-model="form.specId" size="small" clearable>
            <el-option v-for="item in specList" :key="item.specId" :label="item.specName" :value="item.specId" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div style="width:125px">
      <el-button size="small" type="primary" @click="handleQueryBtnClick">
        查询
      </el-button>
      <el-button size="small" type="primary" plain @click="resetFormBtnHandle">
        重置
      </el-button>
    </div>
  </div>
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import folderService from "@/CommonDP/service/folder-service";
import { mapState } from "vuex";
import { storage } from "@/CommonDP/utils";
function Form() {
  return {
    prjId: "",
    flowInstanceOwnerId: "",
    approveTime: "",
    flowType: "",
    keywords: "",
    specId: '',
    status: null
  };
}
export default {
  props: {
    showPrjSelect: {
      type: Boolean,
      default: true
    },
    showApplicantSelect: {
      type: Boolean,
      default: true
    },
    showStatusSelect: {
      type: Boolean,
      default: false
    },
    showflowTypeSelect: {
      type: Boolean,
      default: true
    },
    keywordsPlaceholder: {
      type: String,
      default: '标题/内容/申请人/审批人'
    },
    showPrjKeywords: {
      type: Boolean,
      default: true
    },
    showSpecIdSelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: new Form(),
      approvalProjectList: [],
      definitionList: [],
      userList: [],
      prjId: "",
      statusList: [
        { value: 1, label: "已通过" },
        { value: 2, label: "审批中" },
        { value: 3, label: "已撤回" },
        { value: 0, label: "已驳回" }
      ],
      specList: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.prjId = storage.get("updatePrjcook");
    this.getDefinitionList();
    if (this.showApplicantSelect) {
      this.getUserList();
    }
    if (this.showPrjSelect) {
      this.getProjects();
    }
    this.querySpecList();
  },
  methods: {
    // 接口：获取表单的数据
    getForm() {
      const approveTime = this.form.approveTime || [];
      const params = {
        ...this.form,
        startDate: approveTime && approveTime.length > 0 ? approveTime[0] : "",
        endDate: approveTime && approveTime.length > 1 ? approveTime[1] : "",
        prjId: this.showPrjSelect ? this.form.prjId : this.prjId,
        enterpriseId: this.enterpriseId
      };
      return params;
    },
    // 查询专业
    async querySpecList() {
      const params = { enterpriseId: this.enterpriseId };
      const res = await folderService.queryspeclist2(params);
      this.specList = res.data || [];
    },

    // 以下是内部方法
    resetForm() {
      this.form = new Form();
    },
    // 查询流程类型
    async getDefinitionList() {
      const res = await flowService.downList(this.enterpriseId);
      this.definitionList = res.data || [];
    },
    // 查询申请人
    async getUserList() {
      const res = await flowService.applicant(this.enterpriseId);
      this.userList = res.data || [];
    },
    async getProjects() {
      const query = { enterpriseId: this.enterpriseId };
      const res = await flowService.queryApplicantProjects(query);
      this.approvalProjectList = res.data || [];
    },
    resetFormBtnHandle() {
      this.resetForm();
      this.$emit("change", this.getForm());
    },

    handleQueryBtnClick() {
      this.$emit("change", this.getForm());
    }
  }
};
</script>

<style lang="scss" scoped>
.header-midd {
  width: 100%;
  margin: 15px 0 10px 0;
  display: flex;
  justify-content: space-between;
  .el-form {
    width: 100%;
    /deep/ .el-form-item {
      margin-bottom: 5px !important;
    }
  }
}
</style>
